// extracted by mini-css-extract-plugin
export var dropdownIcon = "_nk-6";
export var imgContainer = "_nk-3";
export var menuIcon = "_nk-5";
export var pillWrapper = "_nk-2";
export var pillsContainer = "_nk-1";
export var subscriptionCard = "_nk-0";
export var subscriptionLogo = "_nk-4";